import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

let clone = window.structuredClone || JSON.clone

let Resource = props => {
  let { t } = useTranslation()

  let [resource, setResource] = useState(clone(props.resource))

  let [license, setLicense] = useState(clone(props.license))
  let [licenses, setLicenses] = useState()

  let [locations, setLocations] = useState(clone(props.location))
  let [location, setLocation] = useState()

  let [specialties, setSpecialties] = useState()
  let [specialty, setSpecialty] = useState()

  let [identification, setIdentification] = useState(clone(props.identification))
  let [identifications, setIdentifications] = useState()

  let [warnings, setWarnings] = useState({})

  let onChangeLicense = ({ target: { name, value } }) => {
    let license = clone(
      licenses.find(l => l.value === value && !l.deleted)
    )
    setLicense(license)
    if (props.onChangeLicense) props.onChangeLicense(license)
  }

  let onChangeLocation = ({ target: { name, value } }) => {
    let location = locations.find(l => l.id === value)
    location ||= locations.find(l => l.place_id === value)
    location ||= locations.find(l => l.placeId === value)
    location ||= locations.find(l => l.placeID === value)
    location = clone(location)
    setLocation(location)
    if (props.onChangeLocation) props.onChangeLocation(location)
  }

  let onChangeSpecialty = ({ target: { name, value } }) => {
    let specialty = clone(specialties.find(l => l.id === value))
    setSpecialty(specialty)
    if (props.onChangeSpecialty) props.onChangeSpecialty(specialty)
  }

  useEffect(() => {
    if (!props.resource?.id) {
      setResource()
    } else {
      setResource(clone(props.resource))
    }
  }, [props.resource])

  useEffect(() => {
    if (resource?.id && props.teamData?.id) try {
      let payload = { locations: {}, licenses: {}, identifications: {} }

      let specialties = clone(resource.specialties) || []
      let financiers = clone(resource.financiers) || []

      let locations = clone(resource.locations) || []
      for (let location of locations) {
        let id = location.id || location.place_id || location.placeId || location.placeID
        if (!id) continue
        payload.locations[id] ||= {
          id,
          name: location.name,
          address: location.address || location.label,
          emails: location.emails || [],
          phones: location.phone || location.phones || [],
          coords: location.coords || {}
        }
      }

      let licenses = clone(resource.licenses) || []
      for (let { value, deleted, jurisdiction, specialty, specialties, kind } of licenses) {
        if (deleted || !value) continue
        kind ||= (/caba/i.test(jurisdiction) ? 'M.N.' : 'M.P.')
        let label = [kind?.replaceAll('.', ''), value].filter(Boolean).join(' ')
        payload.licenses[value] ||= {
          label,
          value,
          jurisdiction: jurisdiction?.replace('-', '/')?.split('/')?.filter(Boolean)?.reverse()?.at(0),
          state: jurisdiction,
          specialty,
          specialties,
          kind
        }
      }

      let identifications = clone(resource.docs?.filter(doc => doc.type === 'identification') || [])
      for (let { value, deleted, jurisdiction, kind } of identifications) {
        if (deleted || !value) continue
        payload.identifications[value] ||= {
          label: value,
          value: value,
          jurisdiction: jurisdiction?.replace('-', '/')?.split('/')?.filter(Boolean)?.reverse()?.at(0),
          state: jurisdiction,
          kind
        }
      }

      const finalLocations = Object.values(payload.locations);
      const finalLicenses = Object.values(payload.licenses);
      const finalIdentifications = Object.values(payload.identifications);

      let hasLocation = finalLocations.length > 0;
      let hasSpecialty = specialties.length > 0;
      let hasFinancier = financiers.length > 0;

      if (!hasLocation || !hasSpecialty || !hasFinancier) {
        for (const setting of props.teamData?.settings) {
          if (setting.resource?.id !== resource.id) continue;
          if (setting.location?.ranges?.length > 0) hasLocation ||= true;
          if (setting.specialties?.length > 0) hasSpecialty ||= true;
          if (setting.financiers?.length > 0 && setting.financiers.some(financier => financier.active !== false)) hasFinancier ||= true;
        }
      }

      setLocations(finalLocations)
      setLicenses(finalLicenses)
      setIdentifications(finalIdentifications)
      setSpecialties(specialties)

      setWarnings(warnings => {
        const newWarnings = { ...warnings }

        if (!hasLocation) {
          newWarnings.flag ||= true
          newWarnings.location = true
        } else {
          newWarnings.location = false
        }

        if (finalLicenses.length === 0) {
          newWarnings.flag ||= true
          newWarnings.license = true
        } else {
          newWarnings.license = false
        }

        if (finalIdentifications.length === 0) {
          newWarnings.flag ||= true
          newWarnings.identification = true
        } else {
          newWarnings.identification = false
        }

        if (!hasSpecialty) {
          newWarnings.flag ||= true
          newWarnings.specialty = true
        } else {
          newWarnings.specialty = false
        }

        if (!hasFinancier) {
          newWarnings.flag ||= true
          newWarnings.financier = true
        } else {
          newWarnings.financier = false
        }

        // dob debe respetar formato YYYY-MM-DD
        const dobPattern = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/
        if (!resource.dob || !dobPattern.test(resource.dob)) {
          newWarnings.flag ||= true
          newWarnings.dob = true
        } else {
          newWarnings.dob = false
        }

        if (!resource.gender) {
          newWarnings.flag ||= true
          newWarnings.gender = true
        } else {
          newWarnings.gender = false
        }

        return newWarnings
      })
    } catch (e) {
      console.error(e)
    }
  }, [resource, props.teamData])

  useEffect(() => {
    if (Array.isArray(locations) && !location?.id) {
      let payload = clone(locations[0])
      setLocation(payload)
      if (props.onChangeLocation) props.onChangeLocation(payload)
      if (!payload?.id) {
        setWarnings(warnings => ({ ...warnings, flag: true, location: true }))
      }
    }
  }, [locations, location])

  useEffect(() => {
    if (Array.isArray(licenses) && !license?.value) {
      let payload = clone(licenses[0])
      setLicense(payload)
      if (props.onChangeLicense) props.onChangeLicense(payload)
      if (!payload?.value) {
        setWarnings(warnings => ({ ...warnings, flag: true, license: true }))
      }
    }
  }, [licenses, license])

  useEffect(() => {
    if (Array.isArray(identifications) && !identification?.value) {
      let payload = clone(identifications[0])
      setIdentification(payload)
      if (props.onChangeIdentification) props.onChangeIdentification(payload)
      if (!payload?.value) {
        setWarnings(warnings => ({ ...warnings, flag: true, identification: true }))
      }
    }
  }, [identifications, identification])

  useEffect(() => {
    if (Array.isArray(specialties) && !specialty?.id) {
      let payload = clone(specialties[0])
      setSpecialty(payload)
      if (props.onChangeSpecialty) props.onChangeSpecialty(payload)
      if (!payload?.id) {
        setWarnings(warnings => ({ ...warnings, flag: true, specialty: true }))
      }
    }
  }, [specialties, specialty])

  useEffect(() => {
    if (props.onWarnings) props.onWarnings(warnings)
  }, [warnings, props.onWarnings])


  if (!resource?.id) return null

  if (!locations) return null
  if (!licenses) return null
  if (!specialties) return null
  if (!identifications) return null
  if (!resource?.dob) return null
  if (!resource?.gender) return null

  if (!warnings.flag && !location?.id) return null
  if (!warnings.flag && !license?.value) return null
  if (!warnings.flag && !specialty?.id) return null
  if (!warnings.flag && !identification?.value) return null

  return (
    <div className="bg-light rounded border" style={{ padding: '7px 10px' }}>
      <h6 className="m-0">{resource.label}</h6>
      <div className="lh-1 row g-2">
        <div className="col-12 col-md-4 d-flex flex-column overflow-hidden" style={{ minWidth: 0 }}>
          <small>{t('ehr:prescription_form_specialty', 'Especialidad')}:</small>
          {specialties.length <= 0 ? (
            <small className="text-secondary text-truncate">{t('ehr:prescription_form_no_specialty', 'Sin especialidad')}</small>
          ) : specialties.length === 1 && specialty?.id ? (
            <small className="text-secondary text-truncate" title={t(specialty.id, specialty.label)}>{t(specialty.id, specialty.label)}</small>
          ) : (
            <select value={specialty?.id || ''} onChange={onChangeSpecialty} className="p-0 text-xs border-0 bg-transparent text-primary text-truncate w-100" style={{ maxWidth: '100%' }} title={specialty ? t(specialty.id, specialty.label) : ''}>
              {specialties.map(specialty => (
                <option className="text-truncate"
                  key={specialty.id}
                  value={specialty.id}
                >{t(specialty.id, specialty.label)}</option>
              ))}
            </select>
          )}
        </div>

        <div className="col-12 col-md-4 d-flex flex-column overflow-hidden" style={{ minWidth: 0 }}>
          <small>{t('ehr:prescription_form_license', 'Licencia')}:</small>
          {licenses.length <= 0 ? (
            <small className="text-secondary">{t('ehr:prescription_form_no_license', 'Sin licencia para recetar')}</small>
          ) : licenses.length === 1 && license?.value ? (
            // Bug real (auditoría 2026-08-16): a esta rama, a diferencia de
            // las de specialty/location de acá arriba/abajo, le faltaba
            // chequear que `license` ya esté resuelto. `license` lo puebla
            // un efecto async separado, DESPUÉS de que licenses/warnings se
            // setean en el efecto de carga de datos. warnings.flag puede dar
            // true en el mismo render por otro motivo (dob, specialty,
            // financier faltante) sin que license todavía exista, salteando
            // el guard de arriba (`if (!warnings.flag && !license?.value)
            // return null`) y cayendo acá con `license` undefined — throw al
            // leer license.kind, sin ErrorBoundary que lo contenga.
            <small className="text-secondary text-truncate" title={[parseInt(license?.value || '')?.toLocaleString('es-AR'), license.kind, license?.jurisdiction].join(' ') || ''}>{[parseInt(license?.value || '')?.toLocaleString('es-AR'), license.kind, license?.jurisdiction].join(' ') || ''}</small>
          ) : (
            <select value={license?.value || ''} onChange={onChangeLicense} className="p-0 text-xs border-0 bg-transparent text-primary text-truncate w-100" style={{ maxWidth: '100%' }}>
              {licenses.map(license => (
                <option
                  key={license.value}
                  value={license.value}
                >{[license.label || license.value, license.jurisdiction].filter(Boolean).join(' - ')}</option>
              ))}
            </select>
          )}
        </div>

        <div className="col-12 col-md-4 d-flex flex-column overflow-hidden" style={{ minWidth: 0 }}>
          <small>{t('ehr:prescription_form_address', 'Direccion')}:</small>
          {locations.length <= 0 ? (
            <small className="text-secondary text-truncate">{t('ehr:prescription_form_no_address', 'Sin licencia para recetar')}</small>
          ) : locations.length === 1 && location ? (
            <small className="text-secondary text-truncate" title={location.address}>{location.address}</small>
          ) : (
            <select value={location?.id || ''} onChange={onChangeLocation} className="p-0 text-xs border-0 bg-transparent text-primary text-truncate w-100" style={{ maxWidth: '100%' }} title={location?.name || location?.address}>
              {locations.map(location => (
                <option key={location.id} value={location.id}>{location.name || location.address}</option>
              ))}
            </select>
          )}
        </div>
      </div>
    </div>
  )
}

export default Resource
